import { BaseModel } from './BaseModel';

export class NcCodice extends BaseModel {
  organizzazioneId: number;
  idCodNc?: number;   // null = creato manualmente, valorizzato = collegato a ESOLVER
  risorsaId?: number; // collegamento opzionale a una risorsa
  tipoNc: number;     // 0 = prodotto/produzione, 1 = processo/ingresso merce
  reparto?: string;
}
